export const CLIENT_GET_DATA = 'CLIENT_GET_DATA'
export const CLIENT_GET_DATA_SUCCESS = 'CLIENT_GET_DATA_SUCCESS'
export const CLIENT_GET_DATA_FAILURE = 'CLIENT_GET_DATA_FAILURE'
export const CLIENT_EMPTY = 'CLIENT_EMPTY'

export const CLIENTS_GET_DATA = 'CLIENTS_GET_DATA'
export const CLIENTS_GET_DATA_SUCCESS = 'CLIENTS_GET_DATA_SUCCESS'
export const CLIENTS_GET_DATA_FAILURE = 'CLIENTS_GET_DATA_FAILURE'
export const CLIENTS_EMPTY = 'CLIENTS_EMPTY'

export const CLIENT_BREADCRUMB_GET_DATA = 'CLIENT_BREADCRUMB_GET_DATA'
export const CLIENT_BREADCRUMB_GET_DATA_SUCCESS = 'CLIENT_BREADCRUMB_GET_DATA_SUCCESS'
export const CLIENT_BREADCRUMB_GET_DATA_FAILURE = 'CLIENT_BREADCRUMB_GET_DATA_FAILURE'

export const CLIENT_ALL_BREADCRUMB_GET_DATA = 'CLIENT_ALL_BREADCRUMB_GET_DATA'
export const CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS = 'CLIENT_ALL_BREADCRUMB_GET_DATA_SUCCESS'
export const CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE = 'CLIENT_ALL_BREADCRUMB_GET_DATA_FAILURE'

export const CLIENT_CREATE_FOLDER = 'CLIENT_CREATE_FOLDER'
export const CLIENT_CREATE_FOLDER_SUCCESS = 'CLIENT_CREATE_FOLDER_SUCCESS'
export const CLIENT_CREATE_FOLDER_FAILURE = 'CLIENT_CREATE_FOLDER_FAILURE'
export const CLIENT_CREATE_ROOT_FOLDER_SUCCESS = 'CLIENT_CREATE_ROOT_FOLDER_SUCCESS'

export const CLIENT_EDIT_FOLDER = 'CLIENT_EDIT_FOLDER'
export const CLIENT_EDIT_FOLDER_SUCCESS = 'CLIENT_EDIT_FOLDER_SUCCESS'
export const CLIENT_EDIT_FOLDER_FAILURE = 'CLIENT_EDIT_FOLDER_FAILURE'

export const CLIENT_DELETE_FOLDER = 'CLIENT_DELETE_FOLDER'
export const CLIENT_DELETE_FOLDER_SUCCESS = 'CLIENT_DELETE_FOLDER_SUCCESS'
export const CLIENT_DELETE_FOLDER_FAILURE = 'CLIENT_DELETE_FOLDER_FAILURE'

export const CLIENT_MOVE_FOLDER = 'CLIENT_MOVE_FOLDER'
export const CLIENT_MOVE_FOLDER_SUCCESS = 'CLIENT_MOVE_FOLDER_SUCCESS'
export const CLIENT_MOVE_FOLDER_FAILURE = 'CLIENT_MOVE_FOLDER_FAILURE'

export const CLIENT_SHARE_FOLDER = 'CLIENT_SHARE_FOLDER'
export const CLIENT_SHARE_FOLDER_SUCCESS = 'CLIENT_SHARE_FOLDER_SUCCESS'
export const CLIENT_SHARE_FOLDER_FAILURE = 'CLIENT_SHARE_FOLDER_FAILURE'

export const CLIENT_SET_UPLOADING = 'CLIENT_SET_UPLOADING'
export const CLIENT_UNSET_UPLOADING = 'CLIENT_UNSET_UPLOADING'

export const CLIENT_DOWNLOAD_PROGRESS = 'CLIENT_DOWNLOAD_PROGRESS'

export const CLIENT_CHANGE_LOGO = 'CLIENT_CHANGE_LOGO'
export const CLIENT_CHANGE_LOGO_SUCCESS = 'CLIENT_CHANGE_LOGO_SUCCESS'
export const CLIENT_CHANGE_LOGO_FAILURE = 'CLIENT_CHANGE_LOGO_FAILURE'

export const CLIENT_SET_PID = 'CLIENT_SET_PID'
export const CLIENT_SET_PID_SUCCESS = 'CLIENT_SET_PID_SUCCESS'
export const CLIENT_SET_PID_FAILURE = 'CLIENT_SET_PID_FAILURE'

export const CREATE_CLIENT_LIST = 'CREATE_CLIENT_LIST'
export const CREATE_CLIENT_LIST_SUCCESS = 'CREATE_CLIENT_LIST_SUCCESS'
export const CREATE_CLIENT_LIST_FAILURE = 'CREATE_CLIENT_LIST_FAILURE'

export const DELETE_CLIENT_LIST = 'DELETE_CLIENT_LIST'
export const DELETE_CLIENT_LIST_SUCCESS = 'DELETE_CLIENT_LIST_SUCCESS'
export const DELETE_CLIENT_LIST_FAILURE = 'DELETE_CLIENT_LIST_FAILURE'

export const UPDATE_CLIENT_LIST = 'UPDATE_CLIENT_LIST'
export const UPDATE_CLIENT_LIST_SUCCESS = 'UPDATE_CLIENT_LIST_SUCCESS'
export const UPDATE_CLIENT_LIST_FAILURE = 'UPDATE_CLIENT_LIST_FAILURE'

export const SET_QTY_FILES_ERROR = 'SET_QTY_FILES_ERROR'

export const HANDLE_USER_ATTEMPS = 'HANDLE_USER_ATTEMPS'
export const SET_NUMBER_ATTEMPS = 'SET_NUMBER_ATTEMPS'

export const HANDLE_IS_TOUR_OPEN = 'HANDLE_IS_TOUR_OPEN'
export const HANDLE_IS_FETCHING_SAURON_REPORT = 'HANDLE_IS_FETCHING_SAURON_REPORT'

export const SHOW_VERSION_ASSET = 'SHOW_VERSION_ASSET';
export const HIDE_VERSION_ASSET = 'HIDE_VERSION_ASSET';
export const ADD_FILE_VERSION_ASSET = 'ADD_FILE_VERSION_ASSET';
export const REMOVE_FILE_VERSION_ASSET = 'REMOVE_FILE_VERSION_ASSET';
export const UPDATE_FILE_PROGRESS_VERSION_ASSET = 'UPDATE_FILE_PROGRESS_VERSION_ASSET';
export const SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET = 'SET_UPLOAD_OBJECT_TO_FILE_VERSION_ASSET';
export const SET_ERROR_STATE_TO_FILE_VERSION_ASSET = 'SET_ERROR_STATE_TO_FILE_VERSION_ASSET';
export const SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET = 'SET_SUCCESS_STATE_TO_FILE_VERSION_ASSET';
// export const SET_IS_UPLOADING_VERSION = 'SET_IS_UPLOADING_VERSION';

export const SET_IS_UPLOADING_VERSION = 'SET_IS_UPLOADING_VERSION'
export const UNSET_IS_UPLOADING_VERSION = 'UNSET_IS_UPLOADING_VERSION'

export const EMPTY_VERSION_ASSET = "EMPTY_VERSION_ASSET";
export const SET_VERSION_TAGS_VERSION_ASSET = "SET_VERSION_TAGS_VERSION_ASSET";
export const CANCEL_UPLOAD_VERSION = "CANCEL_UPLOAD_VERSION";
export const ERROR_UPLOAD_VERSION = "ERROR_UPLOAD_VERSION";
export const SET_TAGS_UPLOAD_VERSION = "SET_TAGS_UPLOAD_VERSION";
export const REMOVE_TAG_ASSET_VERSION = "REMOVE_TAG_ASSET_VERSION"
export const SET_USERS_OPTIONS = 'SET_USERS_OPTIONS'
export const SET_MENTIONED_USERS = 'SET_MENTIONED_USERS'

export const CREATE_CLIENT_MEDIA = 'CREATE_CLIENT_MEDIA'
export const CREATE_CLIENT_MEDIA_SUCCESS = 'CREATE_CLIENT_MEDIA_SUCCESS'
export const CREATE_CLIENT_MEDIA_FAILURE = 'CREATE_CLIENT_MEDIA_FAILURE'

export const CREATE_CLIENT_STATUS = 'CREATE_CLIENT_STATUS'
export const CREATE_CLIENT_STATUS_SUCCESS = 'CREATE_CLIENT_STATUS_SUCCESS'
export const CREATE_CLIENT_STATUS_FAILURE = 'CREATE_CLIENT_STATUS_FAILURE'

export const DELETE_CLIENT_MEDIA = 'DELETE_CLIENT_MEDIA'
export const DELETE_CLIENT_MEDIA_SUCCESS = 'DELETE_CLIENT_MEDIA_SUCCESS'
export const DELETE_CLIENT_MEDIA_FAILURE = 'DELETE_CLIENT_MEDIA_FAILURE'

export const DELETE_CLIENT_STATUS = 'DELETE_CLIENT_STATUS'
export const DELETE_CLIENT_STATUS_SUCCESS = 'DELETE_CLIENT_STATUS_SUCCESS'
export const DELETE_CLIENT_STATUS_FAILURE = 'DELETE_CLIENT_STATUS_FAILURE'

export const CLIENTS_TYPE_GET_DATA = 'CLIENTS_TYPE_GET_DATA'
export const CLIENTS_TYPE_GET_DATA_SUCCESS = 'CLIENTS_TYPE_GET_DATA_SUCCESS'
export const CLIENTS_TYPE_GET_DATA_FAILURE = 'CLIENTS_TYPE_GET_DATA_FAILURE'

export const CLIENTS_TYPE_BUSINESS_GET_DATA = 'CLIENTS_TYPE_BUSINESS_GET_DATA'
export const CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS = 'CLIENTS_TYPE_BUSINESS_GET_DATA_SUCCESS'
export const CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE = 'CLIENTS_TYPE_BUSINESS_GET_DATA_FAILURE'

export const CLIENT_END_FOLDER_ACTION = 'CLIENT_END_FOLDER_ACTION'

export const SHARE_FOLDER_RESET = 'SHARE_FOLDER_RESET'
export const CLIENT_DATA_CLEAN = 'CLIENT_DATA_CLEAN'
export const UPDATE_METADATA_CLIENT = 'UPDATE_METADATA_CLIENT'

export const CLIENT_ROOT_FOLDER_NAVBAR = 'CLIENT_ROOT_FOLDER_NAVBAR'
